import styled from 'styled-components'

export const Annotation = styled.div`
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
